exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".brief-loading img[data-v-53d3571c] {\n  width: 100px;\n  height: 100px;\n}\n.index-brief[data-v-53d3571c] {\n  margin-top: 8px;\n  margin-bottom: 20px;\n}\n.index-brief *[data-v-53d3571c] {\n    line-height: 1.3;\n}\n.index-brief .number[data-v-53d3571c] {\n    color: #f5ae5c;\n}\n", ""]);

